__turbopack_context__.v({
  "SDropDownWrapper": "KSIZda_SDropDownWrapper",
  "SMenuItem": "KSIZda_SMenuItem",
  "SMenuItems": "KSIZda_SMenuItems",
});
